import { ExclamationCircleFilled, LeftCircleTwoTone, RightCircleTwoTone } from "@ant-design/icons";
import { Layout, Menu, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Link, useLocation, useMatches, useSubmit } from "react-router-dom";
import { useApp } from '../../providers/app/app-context.js';
import style from './sidebar.module.scss';
import './sidebar.scss';
const { confirm } = Modal;
const { Sider } = Layout;

const getMenuItems = (items, parent = '') => {
  if (!items || items.filter((item) => item.showOnMenu).length == 0) return undefined

  return items.filter((item) => item.showOnMenu).map((item) => {
    const { url, nolink = false, label, icon = undefined, children = null } = item
    const relativeUrl = url?.length ? url : parent
    return {
      label: nolink ? label : <Link to={relativeUrl} className='nav-text' title={label}>{label}</Link>,
      key: (!url && relativeUrl === parent) ? `${relativeUrl}?index` : relativeUrl,
      icon: icon,
      children: getMenuItems(children, relativeUrl),
      id: url + parent,
    }
  })
}

export default function Sidebar(props) {
  const { routes } = props;
  const { theme, sidebarCollapsed, actions } = useApp()
  const location = useLocation();
  const menuItems = useMemo(() => getMenuItems(routes), [routes])
  const matches = useMatches()
  const pathnames = (matches?.map(({ pathname }) => pathname) || []).filter(Boolean);
  const currentPathWithIndex = `${location?.pathname || ''}?index`;
  const selectedKeys = [...pathnames, currentPathWithIndex]
  const openKeys = [...pathnames]
  const submit = useSubmit()

  const handleLogout = () => {
    submit({
      action: 'logout',
      index: false
    }, {
      method: 'post',
      action: '/'
    })
  };

  const showConfirm = () => {
    confirm({
      title: 'Are you sure you want to Logout ?',
      icon: <ExclamationCircleFilled />,
      okText:'Yes',
      onOk() {
        handleLogout()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  return (
    <Sider theme={theme} trigger={null} collapsible collapsed={sidebarCollapsed} className={style.sider}>
      <div className="logo-wraper"></div>
      <div className="sidebar-toggle" onClick={actions.toggleSidebarCollapsed}>
        {sidebarCollapsed ?
          <RightCircleTwoTone twoToneColor="#FA5359" /> :
          <LeftCircleTwoTone twoToneColor="#FA5359" />}
      </div>
      <></>
      {/* <div className="user-info">
        <div className="text" style={{ 'textAlign': 'center' }}>
          <Avatar size={64} icon={<UserOutlined />} />
          <h4><b>{user.name}</b></h4>
          <p>{user.role}</p>
        </div>

      </div> */}
      <Menu
        // key={location.pathname}
        // defaultSelectedKeys={[...pathnames, ...pathnames.map(path => `${path}?index`), currentPathWithIndex]}
        selectedKeys={selectedKeys}
        defaultOpenKeys={openKeys}
        mode="inline"
        theme={theme}
        className={style.menu}
        inlineCollapsed={sidebarCollapsed}
        items={menuItems}
      />
      {/* <div className="toggle-theme">
        <Switch checkedChildren="☀️" unCheckedChildren="🌕" checked={theme !== 'dark'} onChange={actions.toggleTheme} size="large" />
      </div> */}

      <div onClick={() => {
        showConfirm()
      }} className={style.logout}>
        LOGOUT
      </div>



      <a href={process.env.REACT_APP_BUILD_LOGS} target='blank'>
        <div className={style.footer}>
          Version {process.env.REACT_APP_CURRENT_BUILD}
        </div>

      </a>
    </Sider>
  )
}


Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
}
